import { Injectable } from '@angular/core';
import { IndividualConfig, ToastrService } from 'ngx-toastr';

/**
 * Service utilisé pour afficher les notifications à l'utilisateur.
 */
@Injectable({
    providedIn: 'root',
})
export class WorkflowNotificationService {
    private displayedToasts = new Map<string, number>();

    /**
     * Constructeur
     */
    constructor(protected toastr: ToastrService) {}

    /**
     * Affiche une notification d'erreur.
     * @param title : Titre de la notification.
     * @param message: Message de la notification.
     * @param options: Options de personnalisation de la notification.
     */
    public displayError(folderId: string, title: string, message: string, persistent: boolean) {
        let options: Partial<IndividualConfig> = {
            enableHtml: true,
            disableTimeOut: persistent,
            tapToDismiss: !persistent,
        };
        let toast = this.toastr.error(message, title, options);

        if (persistent) {
            this.displayedToasts.set(folderId, toast.toastId);
        }
    }

    /**
     * Affiche une notification d'information.
     * @param title : Titre de la notification.
     * @param message: Message de la notification.
     * @param options: Options de personnalisation de la notification.
     */
    public displayInfo(folderId: string, title: string, message: string, persistent: boolean) {
        let options: Partial<IndividualConfig> = {
            enableHtml: true,
            disableTimeOut: persistent,
            tapToDismiss: !persistent,
            toastClass: 'workflow-toast',
        };

        let toast = this.toastr.info(message, title, options);

        if (persistent) {
            this.displayedToasts.set(folderId, toast.toastId);
        }
    }

    /**
     * Affiche une notification de succès.
     * @param title : Titre de la notification.
     * @param message: Message de la notification.
     * @param options: Options de personnalisation de la notification.
     */
    public displaySuccess(folderId: string, title: string, message: string, persistent: boolean) {
        let options: Partial<IndividualConfig> = {
            enableHtml: true,
            disableTimeOut: persistent,
            tapToDismiss: !persistent,
        };
        let toast = this.toastr.success(message, title, options);

        if (persistent) {
            this.displayedToasts.set(folderId, toast.toastId);
        }
    }

    /**
     * Affiche une notification d'avertissement.
     * @param title : Titre de la notification.
     * @param message: Message de la notification.
     * @param options: Options de personnalisation de la notification.
     */
    public displayWarning(folderId: string, title: string, message: string, persistent: boolean) {
        let options: Partial<IndividualConfig> = {
            enableHtml: true,
            disableTimeOut: persistent,
            tapToDismiss: !persistent,
        };
        let toast = this.toastr.warning(message, title, options);

        if (persistent) {
            this.displayedToasts.set(folderId, toast.toastId);
        }
    }

    public closeToast(folderId: string) {
        if (this.displayedToasts.has(folderId)) {
            let toastId = this.displayedToasts.get(folderId);
            let result = this.toastr.remove(toastId);
        }
    }
}
